<template>
  <div class="view pa24">
    <el-dialog
        :title="title"
        width="800px"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="dealerRuleForm"
          label-width="100px"
          class="ruleForm"
      >

        <el-form-item label="部门名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import {fetchAddOrEditDep} from '@/api/customPageClass.js'
// import Map from './aliMap.vue'
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from 'element-china-area-data'

export default {
  name: "productList",
  components: {
    // BaiduMap,
    // Map
  },
  props: [],

  data() {
    return {
      source: '',
      //测试
      provinces: [],
      dialogVisible: false,
      options: regionData,
      title: '添加部门',
      ruleForm: {
        name: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入部门名称', trigger: 'blur'},
        ],
      },
      mapZoom: 15,
      mapCenter: {lng: 0, lat: 0},
      selectedOptions: [],
      type: 'add',
      id: '',

    };
  },
  onShow() {

  },
  methods: {
    getNullArea() {
      let obj = {
        province: '',
        city: '',
        county: '',
        data: [],
        address: ''
      }
      return obj
    },
    addItem(index) {
      // this.ruleForm.areaArr.splice(index, 0, this.getNullArea())
      this.ruleForm.areaArr.push(this.getNullArea())
    },
    delItem(index) {
      this.ruleForm.areaArr.splice(index, 1)
    },

    updateLocation(Addr) {
      // console.log('Addr+++++++++++++++++++++++++', Addr)
      this.ruleForm.address = Addr.orgAddr
      // console.log('this.ruleForm.address', this.ruleForm.address)
      this.$refs.dealerRuleForm.validateField(["address"], (valid,vv) => {
        // console.log('------valid------',valid)
        // if(!valid){
        //   console.log("校验成功")
        // }
      });

      this.ruleForm.coordinate.lng = Addr.lon
      this.ruleForm.coordinate.lat = Addr.lat
      this.ruleForm.province = Addr.province
      this.ruleForm.city = Addr.city
      this.ruleForm.county = Addr.district
      document.querySelector('.search-box-wrapper input').value=this.ruleForm.address
    },
    openDialog(type, data, source) {
      this.source = source
      this.dialogVisible = true
      let v = this
      if (type === 'add') {
        this.title = '添加部门'
        this.type = 'add'
        this.id = ''
        this.ruleForm.name = ''
      } else {
        this.title = '编辑部门'
        this.getData(data)
        this.type = "edit"
        this.id = data.departmentId
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('getList')
    },
    resetForm() {
      this.$refs.dealerRuleForm.resetFields();
    },
    // 获取省市区
    getCity(lng, lat) {
      let vm = this
      return new Promise((resolve, reject) => {
        var geocoder = new AMap.Geocoder({
          radius: 100,
          extensions: "all",
        });
        geocoder.getAddress([lng, lat], function (status, result) {
          if (status === "complete" && result.info === "OK") {
            if (result && result.regeocode) {
              console.log("搜索获取地址的数据-----", result);
              vm.ruleForm.province = result.regeocode.addressComponent.province;
              vm.ruleForm.city = result.regeocode.addressComponent.city;
              vm.ruleForm.county = result.regeocode.addressComponent.district;
              resolve()
            }
          }
        })

      })

    },
    confirmAddDealer() {
      this.$refs.dealerRuleForm.validate((valid) => {
        if (valid) {
          // this.getCity(this.ruleForm.coordinate.lng, this.ruleForm.coordinate.lat).then(res => {
            let params = {
              name: this.ruleForm.name,
            }
            if (this.type === 'edit') {
              params.departmentId = this.id
            }
            fetchAddOrEditDep(params).then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.closeDialog()
              }
            })

          // })

        }
      })
    },
    // 回显
    getData(data) {
      this.ruleForm.name = data.name
    },
    handleChange(index, e) {
      let value = e[0]
      this.ruleForm.areaArr[index].province = value[0] ? value[0] : ''
      this.ruleForm.areaArr[index].city = value[1] ? value[1] : ''
      this.ruleForm.areaArr[index].county = value[2] ? value[2] : ''
      let address = ''
      if(value[0]) {
        address+=CodeToText[value[0]]
        if(value[1]) {
          address+=CodeToText[value[1]]
          if(value[2]) {
            address+=CodeToText[value[2]]
          }
        }
      }
      this.ruleForm.areaArr[index].address = address
      // this.ruleForm.areaArr[index].address = CodeToText[(value[0] ? value[0] : '')] + CodeToText[(value[1]?value[1]:'')] + CodeToText[(value[2] ? value[2] : '')]
      console.log('采集到的数据', this.ruleForm.areaArr)
    },
    handlerBMap({BMap, map}) {
      this.BMap = BMap
      this.map = map
      if (this.ruleForm.coordinate && this.ruleForm.coordinate.lng) {
        this.mapCenter.lng = this.ruleForm.coordinate.lng
        this.mapCenter.lat = this.ruleForm.coordinate.lat
        this.mapZoom = 15
        map.addOverlay(new this.BMap.Marker(this.ruleForm.coordinate))
      } else {
        this.mapCenter.lng = 113.271429
        this.mapCenter.lat = 23.135336
        this.mapZoom = 10
      }
    },

    querySearch(queryString, cb) {
      var that = this
      var myGeo = new this.BMap.Geocoder()
      myGeo.getPoint(queryString, function (point) {
        if (point) {
          that.ruleForm.coordinate = point
          that.makerCenter(point)
        } else {
          that.ruleForm.coordinate = null
        }
      }, this.locationCity)
      var options = {
        onSearchComplete: function (results) {
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = []
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i)
              var item = {value: x.address + x.title, point: x.point}
              s.push(item)
              cb(s)
            }
          } else {
            cb()
          }
        }
      }
      var local = new this.BMap.LocalSearch(this.map, options)
      local.search(queryString)
    },
    handleSelect(item) {
      var {point} = item
      this.ruleForm.coordinate = point
      this.makerCenter(point)
    },
    makerCenter(point) {
      if (this.map) {
        this.map.clearOverlays()
        this.map.addOverlay(new this.BMap.Marker(point))
        this.mapCenter.lng = point.lng
        this.mapCenter.lat = point.lat
        this.mapZoom = 15
      }
    }
  },


};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}
</style>
